module.exports = __webpack_public_path__ + "img/header-empty-list-light.c5de66cb.svg";